import { render, staticRenderFns } from "./SingleSelectElement.vue?vue&type=template&id=0bd173f2&"
import script from "./SingleSelectElement.vue?vue&type=script&lang=ts&"
export * from "./SingleSelectElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports